import { useAtom } from 'jotai';
import { PrimitiveAtom } from 'jotai';
import { useCallback } from 'react';

/**
 * Shared hook for global overlay components (drawers, modals) that are
 * driven by a nullable jotai atom. Sets the atom to undefined on close.
 */
export const useGlobalOverlay = <T>(atom: PrimitiveAtom<T | undefined>) => {
    const [params, setParams] = useAtom(atom);

    const handleClose = useCallback(() => {
        setParams(undefined);
    }, [setParams]);

    return { params, handleClose };
};
